export default __webpack_public_path__ + "static/city_map-65a44283dfe2b89c1b287fd0b7235491.jpg";